// ============================================================
// GGPlayer2InWindowAdapter — resolves /api/player and initializes GGPlayer
// ============================================================
import type { PlayerConfig } from '../core/types';
import { GGPlayer } from '../GGPlayer';
import { AnalyticsPlugin } from '../plugins/AnalyticsPlugin';
import { ClipsPlugin } from '../plugins/clips/ClipsPlugin';
import { ReydenPlugin } from '@/plugins/ReydenPlugin';
import { StreamInfoPlugin } from '@/plugins/stream-info/StreamInfoPlugin';
import { WebSocketPlugin } from '@/plugins/WebSocketPlugin';

export type GGPlayer2InWindowAdapterConfig = PlayerConfig;

export class GGPlayer2InWindowAdapter {
  private player: GGPlayer | null = null;

  constructor(initData?: GGPlayer2InWindowAdapterConfig) {
    if (initData) {
      void this.init(initData);
    }
  }

  async init(config: GGPlayer2InWindowAdapterConfig): Promise<void> {
    if (!config.container) throw new Error('container is required');
    if (!config.streamKey) throw new Error('streamKey is required');

    await this.initInternal(config);
  }

  private async initInternal(config: GGPlayer2InWindowAdapterConfig): Promise<void> {
    if (this.player) {
      this.player.destroy();
      this.player = null;
    }

    const resolvedConfig: PlayerConfig = {
      ...config,
      plugins: [
        new AnalyticsPlugin(),
        new ClipsPlugin(),
        new ReydenPlugin(),
        new StreamInfoPlugin(),
        new WebSocketPlugin(),
      ],
    };
    
    this.player = new GGPlayer(resolvedConfig);
  }

  getPlayer(): GGPlayer | null {
    return this.player;
  }

  destroy(): void {
    if (this.player) {
      this.player.destroy();
      this.player = null;
    }
  }

}

